import CreateNavigationContext from 'app/components/CreateNavigationContext';
import FullScreenLayout from 'app/components/Layouts/FullScreenLayout';
import PrimaryLayout from 'app/components/Layouts/PrimaryLayout';
import PrivateLayout from 'app/components/Layouts/PrivateLayout';
import PublicLayout from 'app/components/Layouts/PublicLayout';
import SecondaryLayout from 'app/components/Layouts/SecondaryLayout';
import {
  conditionalNoLayoutRoutes,
  navRoutes,
  noLayoutRoutes,
  primaryLayoutRoutes,
  publicRoutes,
} from 'app/configs/routes';
import Show from 'app/hoc/Show';
import WithErrorBoundary from 'app/hoc/WithErrorBoundary';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import store from 'store';
import { resetModelTraining } from 'store/modelTraining/actions';

export const renderRoute = ({
  path,
  subRoutes = null,
  element: Element,
  hasChildren = false,
}) => {
  if (!path) {
    return null;
  }

  if (subRoutes) {
    return subRoutes.map(subRoute =>
      renderRoute({ ...subRoute, path: `${path}/${subRoute.path}` })
    );
  }

  if (hasChildren) {
    path += '/*';
  }

  return <Route key={path} path={path} element={<Element />} />;
};

const Routing = () => {
  const {
    featureFlags,
    featureFlagsLoading,
    userInfo: { devrev_session_token },
  } = useSelector(state => state?.common) || {};

  const dispatch = useDispatch();

  useEffect(() => {
    const accessToken = store.getState().user.accessToken;
    if (!accessToken) {
      window?.plugSDK?.shutdown?.();
    } else if (
      import.meta.env.VITE_APP_ENABLE_PLUG_CHAT === 'true' &&
      devrev_session_token
    ) {
      setTimeout(() => {
        window?.plugSDK?.init?.({
          app_id:
            'DvRvStPZG9uOmNvcmU6ZHZydi1pbi0xOmRldm8vMjE4ZlpHdnN4bDpwbHVnX3NldHRpbmcvMV9ffHxfXzIwMjUtMDItMDcgMDg6NDc6MjMuMDQ1MDkwMTA2ICswMDAwIFVUQw==xlxendsDvRv',
          session_token: devrev_session_token,
          enable_session_recording: true,
          disable_plug_chat_window: false,
        });
      }, 5000);
    }
  }, [devrev_session_token]);

  useEffect(() => {
    dispatch(resetModelTraining());
  }, []);

  return (
    <>
      <Show when={!window.navigation}>
        <CreateNavigationContext />
      </Show>

      <Routes>
        <Route element={<PublicLayout />}>
          {publicRoutes.map(route => renderRoute(route))}
        </Route>

        <Route element={<PrivateLayout />}>
          <Route path=':subscriptionId/:packId' element={<FullScreenLayout />}>
            <Route element={<SecondaryLayout />}>
              {navRoutes.map(route => renderRoute(route))}
            </Route>
            {conditionalNoLayoutRoutes
              ?.filter(route => {
                return (
                  route?.featureFlagKey &&
                  featureFlags[route?.featureFlagKey] &&
                  !featureFlagsLoading
                );
              })
              .map(route => {
                return renderRoute(route, true);
              })}
            {noLayoutRoutes.map(route => renderRoute(route))}
          </Route>

          <Route element={<PrimaryLayout />}>
            {primaryLayoutRoutes.map(route => renderRoute(route))}
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default WithErrorBoundary(Routing);
